module.exports = __webpack_public_path__ + "static/img/14002013.5383c5e6.png";